import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=4cc1e50c&scoped=true&"
import script from "./CustomTable.vue?vue&type=script&lang=js&"
export * from "./CustomTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc1e50c",
  null
  
)

export default component.exports